<template>
  <panel :url="url"
         :bg-url="bgUrl"
         bg-align="right-bottom"
         :content="content"
         section="网站统计">
  </panel>
</template>

<script>
import panel from './panel-3'

export default {
  components: {
    panel,
  },
  data () {
    return {
      url: require('@/assets/access_images/access-website.png'),
      bgUrl: require('@/assets/access_images/access-website_bg.png'),
      content: [
        '网站，是一切转化率的源头！',
        '无论是线上，还是线下开发您的投入，都会到官网来进行转化'
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
</style>